var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"d-flex align-center col-12 pa-0"},[_c('text-field',{attrs:{"label":"Add Note"},model:{value:(_vm.noteText),callback:function ($$v) {_vm.noteText=$$v},expression:"noteText"}}),_c('btn',{attrs:{"preset":"add"},on:{"click":_vm.addNote}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }